




















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    FormSearchProducts: () => import('@/components/forms/SearchProducts.vue'),
  },
})
export default class SectionRelatedProducts extends Mixins(Section) {
  @Prop() readonly value!: SectionRelatedProducts;
}
